import missionUncrossableDefaultStyles from '@/components/MissionUncrossable/Board/Streets/Street/Tomato/styles.module.scss';
import { useTomatoSprint } from '@/hooks/missionUncrossable/useTomatoSprint';
import { BetStatusId } from '@/models/bet/status/id';
import { Image } from '@starsoft/common/components';
import { Decimal } from '@starsoft/common/services/Decimal';
import { GameReportBoardBet } from '../props';
import styles from './styles.module.scss';

export default function MissionUncrossableGameReportBoard({
  bet,
}: GameReportBoardBet) {
  const tomatoPosition = useTomatoSprint({
    death: bet?.status?.statusId?.toString() == BetStatusId.Lost?.toString(),
    walk: false,
    win: bet?.status?.statusId?.toString() == BetStatusId.Won?.toString(),
  });

  return (
    <div className={styles.container}>
      <Image
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/mission-uncrossable/tomato-sprite.svg`}
        alt="Tomato"
        format="rectangle"
        width={82}
        height={82}
        preload
        style={{
          objectPosition: tomatoPosition,
        }}
        className={styles.container__image}
      />

      <div
        className={`${missionUncrossableDefaultStyles.multiplier} ${missionUncrossableDefaultStyles['multiplier--relative']}`}
      >
        {Decimal.fromSubunits(bet?.multiplier, {
          scale: 4,
        }).toNumberString()}
      </div>
    </div>
  );
}
